export function PublicResumeSkeleton() {
  return (
    <div
      className="kw-public-resume kw-public-resume--skeleton"
      role="status"
      aria-busy="true"
      aria-label="Loading resume"
    >
      <div className="kw-public-resume-skeleton-page">
        <div className="kw-public-resume-skeleton-header">
          <div className="kw-public-resume-skeleton-avatar" />
          <div className="kw-public-resume-skeleton-header-text">
            <div className="kw-public-skeleton-line wide title" />
            <div className="kw-public-skeleton-line medium" />
            <div className="kw-public-skeleton-line short" />
          </div>
        </div>
        <div className="kw-public-resume-skeleton-section">
          <div className="kw-public-skeleton-line section-title" />
          <div className="kw-public-skeleton-line wide" />
          <div className="kw-public-skeleton-line wide" />
          <div className="kw-public-skeleton-line medium" />
        </div>
        <div className="kw-public-resume-skeleton-section">
          <div className="kw-public-skeleton-line section-title" />
          <div className="kw-public-skeleton-line wide" />
          <div className="kw-public-skeleton-line medium" />
          <div className="kw-public-skeleton-line wide" />
          <div className="kw-public-skeleton-line short" />
        </div>
        <div className="kw-public-resume-skeleton-section">
          <div className="kw-public-skeleton-line section-title" />
          <div className="kw-public-skeleton-line wide" />
          <div className="kw-public-skeleton-line medium" />
        </div>
      </div>
      <span className="sr-only">Loading resume…</span>
    </div>
  );
}
